import React from 'react';
import { useTranslation } from 'react-i18next';
import { RenderDataWithFallback, ListEmpty } from '@anytag/shared-atoms';
import { useInfluencerAddRoute, useSelectItemIds } from '@anytag/shared-hooks';
import { useTiktokInfluencersContext } from '../TiktokInfluencersContext';
import { ProfileWidget } from './ProfileWidget';
import { SimilarInfluencersList } from './SimilarInfluencersList';

export const TiktokInfluencersList = () => {
  const { t } = useTranslation();
  const { selectedItemIds, selectItem } = useSelectItemIds<number>();
  const { allowAddInfluencer, addInfluencerRoute } = useInfluencerAddRoute();
  const { loading, listRecords, getListSelectButtonProps } = useTiktokInfluencersContext();

  return (
    <RenderDataWithFallback
      loading={loading}
      hasNoData={listRecords.length === 0}
      noDataNode={
        <ListEmpty
          linkProps={allowAddInfluencer ? { label: t('add an influencer'), href: addInfluencerRoute } : undefined}
        />
      }
    >
      {listRecords.map((profile, index) => {
        const isSectionOpened = selectedItemIds.includes(profile.socialAccountId);

        return (
          <React.Fragment key={`influencer-${profile.id}-${index}`}>
            <ProfileWidget
              profile={profile}
              isSectionOpened={isSectionOpened}
              css={{ '.info-group': { marginTop: '4px' } }}
              selectButtonProps={getListSelectButtonProps?.(profile)}
              toggleSimilarInfluencersSection={() => selectItem(profile.socialAccountId)}
            />
            {profile.socialAccountId ? (
              <SimilarInfluencersList
                isSectionOpened={isSectionOpened}
                socialAccountId={profile.socialAccountId}
                getListSelectButtonProps={getListSelectButtonProps}
              />
            ) : null}
          </React.Fragment>
        );
      })}
    </RenderDataWithFallback>
  );
};
